import React from 'react'
import Swal from 'sweetalert2'
import { PopUpContainer, PopUpContent, PopUpHeader, PopUpParagraph, PopUpTitle } from './style'
import '../style.css'
import { renderToString } from 'react-dom/server'

export interface ConfirmationUpdateModalProps {
  title: string
  message: string | JSX.Element
  onConfirm?: () => void
  onCancel?: () => void
}

export const confirmationUpdateModal = ({ title, message, onConfirm, onCancel }: ConfirmationUpdateModalProps): void => {
  const content = (
    <PopUpContainer>
      <PopUpHeader>
        <PopUpTitle>{title}</PopUpTitle>
      </PopUpHeader>
      <PopUpContent>
        <PopUpParagraph>{message}</PopUpParagraph>
      </PopUpContent>
    </PopUpContainer>
  )

  Swal.fire({
    showCloseButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Atualizar Agora',
    confirmButtonColor: '#0066B3',
    allowOutsideClick: true,
    showCancelButton: true,
    cancelButtonText: 'Atualizar Mais tarde',
    customClass: {
      title: 'update-popup',
      container: 'update-container',
      popup: 'update-popup',
      confirmButton: 'update-confirm',
      cancelButton: 'update-cancel'
    },
    html: renderToString(content),
    width: '729px',
    heightAuto: false,
    padding: 0,
    backdrop: 'rgba(0,0,0,0.4)'
  }).then((result) => {
    if (result.isConfirmed && typeof onConfirm === 'function') {
      onConfirm()
    } else if (
      result.isDismissed &&
      result.dismiss === Swal.DismissReason.cancel &&
      typeof onCancel === 'function'
    ) {
      onCancel()
    }
  })
}
